import { addSelectedCalendarInStore } from '../actions/internalActions';
import { selectedCalendarsStore } from '../store/store';
import { mutator } from 'satcheljs';

mutator(addSelectedCalendarInStore, actionMessage => {
    const { calendarId, primarySmtpAddress } = actionMessage;
    const selectedCalendars = selectedCalendarsStore().selectedCalendars.get(primarySmtpAddress);
    if (selectedCalendars && selectedCalendars.indexOf(calendarId) < 0) {
        selectedCalendars.push(calendarId);
    }
});
